// extracted by mini-css-extract-plugin
module.exports = {"countSort":"Search_countSort__3c14e","selection":"Search_selection__2neWc","pagination":"Search_pagination__3hKjZ"};